import { Component,OnInit, OnDestroy,ViewChild,ElementRef } from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';

import 'rxjs/add/operator/switchMap';

import {Immagine} from '../beans/immagine';
import {ImmaginiMortiService} from '../services/immagini-morti.service';


declare var OpenSeadragon: any;


@Component({
  selector: 'dettaglio-immagine-morto',
  templateUrl: './dettaglio-immagine-morto.component.html',
  styleUrls: ['./dettaglio-immagine-morto.component.css']
})
export class DettaglioImmagineMortoComponent implements OnInit,OnDestroy {
  
 @ViewChild('mysea', { read: ElementRef }) _vcr:ElementRef;

  immagine:Immagine;
  id:number;
  idBack: number;
  idNext: number;
  nextInt=1;
  viewer:any;

 constructor (private immaginiMortiService: ImmaginiMortiService,private route:ActivatedRoute,private router:Router)
  {}  

  ngOnInit():void{
  

  this.route.params.subscribe( params =>
        {this.id = params['id'];
    	this.idBack=+this.id- +this.nextInt;
    	this.idNext=+this.id+ +this.nextInt;}
    )

this.route.paramMap.switchMap((params:ParamMap)=> this.immaginiMortiService.getImmagine(+params.get('id')))
  .subscribe(immagine=> {this.immagine=immagine;

  	this.viewer = OpenSeadragon({id: "openseadragon1",
        prefixUrl: "assets/openseadragon/images/",
        tileSources: `assets/libri_pyramid/pyramidMorti/${this.immagine._path.replace('jpg','dzi')}`
    });
  });

  
  }

   ngOnDestroy(): void{
   	console.log('Destroing...');
   	this.viewer.destroy();
   }

   next():void{
   	  this._vcr.nativeElement.innerHTML='';
   	this.router.navigate(['/dettaglioImmagineMorto',+this.idNext]);

   }
   back():void{
   	  this._vcr.nativeElement.innerHTML='';
   	this.router.navigate(['/dettaglioImmagineMorto',+this.idBack]);

   }


}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/dettaglio/dettaglio-immagine-morto.component.ts